export default "__VITE_ASSET__whvE9ZPI__"